// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface BookmarkAlt2IconSignature {
  Element: SVGSVGElement;
}

export const BookmarkAlt2Icon: TOC<BookmarkAlt2IconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 2H7C4.795 2 3 3.795 3 6V21C3 21.404 3.244 21.77 3.617 21.924C3.991 22.078 4.421 21.992 4.707 21.707L9 17.414L13.293 21.707C13.484 21.898 13.74 22 14 22C14.129 22 14.259 21.975 14.383 21.924C14.756 21.77 15 21.404 15 21V11H20C20.553 11 21 10.553 21 10V6C21 3.795 19.205 2 17 2ZM13 6V18.586L9.707 15.293C9.512 15.098 9.256 15 9 15C8.744 15 8.488 15.098 8.293 15.293L5 18.586V6C5 4.896 5.896 4 7 4H13.537C13.195 4.589 13 5.271 13 6ZM15 6V9H19V6C19 4.896 18.104 4 17 4C15.896 4 15 4.896 15 6Z"/>
</svg>
</template>;